// Fixed lists of the "Dati Tenax" sections (task 1.5, D-033): the values of
// the database enums, with translated labels.
const choicesOf = (prefix: string, values: readonly string[]) =>
  values.map((id) => ({ id, name: `tenax.people.${prefix}.${id}` }));

export const ORG_TYPES = [
  "club",
  "shop",
  "foreign_retailer",
  "foreign_partner",
  "business_partner",
  "marketplace",
  "supplier",
  "corporate_client",
  "other",
] as const;

export const ROLES = [
  "coach",
  "player",
  "athlete",
  "referent",
  "agent",
  "supplier",
  "press",
  "other",
] as const;

export const orgTypeChoices = choicesOf("org_type", ORG_TYPES);
export const roleChoices = choicesOf("role", ROLES);
export const originChoices = choicesOf("origin", [
  "instagram",
  "fitp",
  "tournament",
  "website",
  "amazon",
  "word_of_mouth",
  "fair",
  "import_excel",
  "coach_database",
  "other",
]);
export const channelChoices = choicesOf("channel", [
  "whatsapp",
  "instagram_dm",
  "phone",
  "email",
  "meeting",
  "other",
]);
export const paymentMethodChoices = choicesOf("payment_method", [
  "riba",
  "bank_transfer",
  "card",
  "other",
]);
export const priorityChoices = [1, 2, 3].map((id) => ({
  id,
  name: `tenax.people.priority.${id}`,
}));

// Month names come from the browser, in Italian like the rest of the dates
export const monthChoices = Array.from({ length: 12 }, (_, index) => ({
  id: index + 1,
  name: new Date(2026, index, 1).toLocaleDateString("it-IT", { month: "long" }),
}));

// Which Tenax fields an organization shows, by type
export const companyFieldsFor = (orgType: string | null | undefined) => ({
  club: orgType === "club",
  shop: orgType === "shop",
  foreignRetailer:
    orgType === "foreign_retailer" || orgType === "foreign_partner",
  corporateClient: orgType === "corporate_client",
});

// Which Tenax fields a person shows, by role
export const contactFieldsFor = (
  roles: readonly string[] | null | undefined,
) => {
  const has = (role: string) => (roles ?? []).includes(role);
  return {
    coach: has("coach"),
    player: has("player") || has("athlete"),
  };
};
